module.exports = __webpack_public_path__ + "static/media/SFCompactDisplay-Thin.68480e99.ttf";